function sierotki(){
    $('section p, section span, h1, h2, h3, h4, h5, h6, p, span').each(function(){
        if($(this).length > 0) {
        var $html = $(this).html();
        $html = $html.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;");
            $(this).empty().html($html);
        }
    });
}